/**
 * @license hugeicons-react v0.2.0
 *
 * See the LICENSE file in the root directory of this source tree.
 */

import r from"../create-hugeicon-component.js";const o=r("GuestHouseIcon",[["path",{d:"M4 5V19H20V3",stroke:"currentColor",key:"k0"}],["path",{d:"M14 19L14 13.5372C14 11.3938 10 11.5836 10 13.5372L10 19",stroke:"currentColor",key:"k1"}],["path",{d:"M14 22L10 22",stroke:"currentColor",key:"k2"}],["path",{d:"M3 5L10.7351 2.26014C11.9889 1.91329 12.0111 1.91329 13.2649 2.26014L21 5",stroke:"currentColor",key:"k3"}],["path",{d:"M12.0119 8H12",stroke:"currentColor",key:"k4"}]]);export{o as default};
